import type { RenderingStrategy } from '@/cms/rendering-strategy/types'
import { HybridPageRegistry, PageRegistry } from '@/cms/pageRegistryTypes'
import { fullReactRenderingStrategy } from '@/cms/rendering-strategy/fullReactRenderingStrategy'
import { hybridRenderingStrategy } from '@/cms/rendering-strategy/hybridRenderingStrategy'
import { mvcRenderingStrategy } from '@/cms/rendering-strategy/mvcRenderingStrategy'

/**
 * TODO DocumentPageProps is a type we should work on.
 * At first I create to contain different props set for _document.tsx MyDocument component
 * Now we are using it in a different way...
 * Maybe we need som sort of partial type and define it separately, understand the props funnel and which is a
 * subset/superset of the other.
 * Maybe it just a rename...
 *
 * Now can be
 * -> getStaticProps return type
 *      -> UniformPageProps depending on if is a page that exist in sitecore or not
 *      -> Normalized set of data (MinimumSlugProps)
 *      -> A mix of both
 * -> custom pages (500, 404, etc) props -> has metadata and some other custom fields not present on the other...
 * -> ??
 */
interface RenderingStrategyPageProps {
  page: {
    fields: {
      useFullReactPage: boolean
    }
    template?: string
  }
  hasReactComponents?: boolean
}

function createRenderingStrategy(
  documentPageProps: RenderingStrategyPageProps,
  pageRegistry: PageRegistry,
  hybridPageRegistry: HybridPageRegistry,
): RenderingStrategy {
  if (documentPageProps.page?.fields?.useFullReactPage || pageRegistry.isPageRegistered(documentPageProps)) {
    return fullReactRenderingStrategy()
  }

  if (hybridPageRegistry.isTemplateRegistered(documentPageProps)) {
    return hybridRenderingStrategy()
  }

  return mvcRenderingStrategy()
}

export default {
  createRenderingStrategy,
}
